<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Christal Arthur was born and raised in the rural Midwest. Raised on a family farm with 11 siblings, she is grateful for her family, educational opportunities, and her work associates who showed good work ethic, integrity, and sincerity in their approach to life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ac49177e